import { Close } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import {
  addVisitTypeApi,
  updateVisitTypeApi,
} from "../../../services/visitType.service";
import VisitTypeSchema from "../../../joi/master/visit-type.schema";

export default function VisitTypeModal({
  open,
  onClose,
  refetch,
  selectedRow = null,
}) {
  const initialState = {
    name: "",
    visitType: "OPD",
    priority: 0,
    new: false,
    followUp: false,
    teleconsultation: false,
    active: true,
  };
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState(initialState);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevValue) => {
      return {
        ...prevValue,
        [name]:
          type === "checkbox"
            ? checked
            : name === "priority"
            ? Number(value)
            : value,
      };
    });
  };

  useEffect(() => {
    if (selectedRow?._id) {
      setFormData({
        ...initialState,
        _id: selectedRow?._id,
        name: selectedRow?.name || "",
        visitType: selectedRow?.visitType || "OPD",
        priority: selectedRow?.priority ?? 0,
        new: selectedRow?.new ?? false,
        followUp: selectedRow?.followUp ?? false,
        teleconsultation: selectedRow?.teleconsultation ?? false,
        active: selectedRow?.active ?? true,
      });
    } else {
      setFormData(initialState);
    }
  }, [open]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let response;

    const { error } = VisitTypeSchema.validate(formData);

    if (error) {
      error.details.forEach((err) => toast.error(err.message));
      return;
    }

    setIsLoading(true);
    if (selectedRow?._id) {
      response = await updateVisitTypeApi(formData);
    } else {
      response = await addVisitTypeApi(formData);
    }
    setIsLoading(false);

    if (response?.code === 200) {
      toast.success(
        `Visit Type ${selectedRow?._id ? "updated" : "added"} successfully`
      );
      setFormData(initialState);
      onClose();
      refetch();
    } else {
      toast.error(response?.message || "Some error occurred.");
    }
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            maxWidth: "unset",
            width: { xs: "95vw", lg: "1100px" },
            bgcolor: "#E5F4FF",
            borderRadius: "20px",
          },
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: "20px",
          }}
        >
          <Typography sx={{ color: "rgba(93, 106, 130, 1)", fontSize: 20 }}>
            {selectedRow?._id ? `Edit Visit Type` : `Add New Visit Type`}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Name"
                name="name"
                value={formData?.name || ""}
                onChange={handleChange}
                required
                fullWidth
                sx={{ bgcolor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Visit Type"
                name="visitType"
                value={formData?.visitType || ""}
                onChange={handleChange}
                required
                fullWidth
                sx={{ bgcolor: "white" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Priority"
                name="priority"
                value={formData?.priority ?? 0}
                onChange={handleChange}
                type="number"
                fullWidth
                sx={{ bgcolor: "white" }}
              />
            </Grid>

            <Grid item xs={12} md={10} lg={8}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="new"
                        checked={formData?.new}
                        onChange={handleChange}
                      />
                    }
                    label="New"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="followUp"
                        checked={formData?.followUp}
                        onChange={handleChange}
                      />
                    }
                    label="Follow Up"
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="teleconsultation"
                        checked={formData?.teleconsultation}
                        onChange={handleChange}
                      />
                    }
                    label="Teleconsultation"
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="active"
                        checked={formData?.active}
                        onChange={handleChange}
                      />
                    }
                    label="Active"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Box sx={{ display: "flex", justifyContent: "center", mt: "20px" }}>
            <Button
              variant="contained"
              type="submit"
              sx={{
                textTransform: "none",
                backgroundColor: "rgba(1, 121, 176, 1)",
                width: "150px",
              }}
              disabled={isLoading}
            >
              {isLoading ? (
                <CircularProgress size={24} />
              ) : selectedRow?._id ? (
                "Update"
              ) : (
                `Submit`
              )}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
